import React from 'react';
import { Button } from '../ui/Button';
const items = [{
  icon: '📗',
  title: 'La Guía de las 7 Hierbas Maestras',
  description: 'Qué hierbas usar, dónde conseguirlas y cómo prepararlas'
}, {
  icon: '🥩',
  title: 'El Truco del Post-Asado',
  description: 'El ritual de 10 minutos para que el asado no dispare su glucosa'
}, {
  icon: '🚶',
  title: 'La Técnica del Movimiento Invisible',
  description: 'El micro-movimiento de 2 minutos que baja la glucosa sin gimnasio'
}];
export function ProductShowcase() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 px-4 bg-gray-50 border-y border-gray-200" data-id="element-173">
      <div className="max-w-4xl mx-auto" data-id="element-174">
        <div className="text-center mb-12" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-176">
            Todo Lo Que Incluye el Protocolo
          </h2>
          <div className="h-1 w-24 bg-emerald-500 mx-auto rounded-full" data-id="element-177"></div>
        </div>

        <div className="flex justify-center mb-12" data-id="element-178">
          <img src="https://cdn.magicpatterns.com/uploads/swco9uh88fgzGaxD6EYQFz/Mockup.png" alt="El Protocolo de Limpieza Glicémica - Pack Completo" className="w-full max-w-md rounded-2xl shadow-2xl" data-id="element-179" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10" data-id="element-180">
          {items.map((item, index) => <div key={index} className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-181">
              <div className="text-3xl mb-3" data-id="element-182">{item.icon}</div>
              <h3 className="font-bold text-gray-900 text-sm mb-2" data-id="element-183">
                {item.title}
              </h3>
              <p className="text-xs text-gray-600" data-id="element-184">{item.description}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-185">
          <Button size="xl" onClick={scrollToOffer} className="shadow-emerald-200 shadow-lg w-full max-w-md" data-id="element-186">
            QUIERO MI PROTOCOLO AHORA
          </Button>
        </div>
      </div>
    </section>;
}